var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.1118C24 5.44369 18.6279 0.0390625 12 0.0390625C5.37205 0.0390625 0 5.44369 0 12.1118C0 18.1383 4.38575 23.1328 10.126 24.0391V15.6047H7.08164V12.1118H10.126V9.45251C10.126 6.42936 11.9145 4.75571 14.6564 4.75571C15.9715 4.75571 17.3458 4.99386 17.3458 4.99386V7.96409H15.8334C14.3408 7.96409 13.8805 8.89684 13.8805 9.84943V12.1118H17.2077L16.6751 15.6047H13.8805V24.0391C19.6142 23.1328 24 18.1383 24 12.1118Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo-facebook.480cb6b16798b722f3a2bf85f134f2b0.svg";
export { ForwardRef as ReactComponent };